import { PropertyType, ToolProvider } from '@/backend/types'
import { defaultToolConfig } from '@/modules/Project/Tools/tool-config-presets'
import type { ToolRegistryItem } from '@/modules/Project/Tools/tool-types'

export const urlScrapeTool: ToolRegistryItem = {
  ...defaultToolConfig,
  label: 'URL Scrape',
  description: 'Scrape data from a URL.',
  outputTypes: [PropertyType.text, PropertyType.json],
  provider: ToolProvider.internal,
  addedAt: new Date('2024-01-01'),
  icon: 'link',
}
